/* ==========================================================================
   2202 OUTFITTERS — Theme JS
   No framework. Vanilla. Minimal. Defer-loaded.
   ========================================================================== */

(function() {
  'use strict';

  // ----- COUNTDOWN -----
  function initCountdown() {
    const els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      els.forEach(el => {
        const targetIso = el.dataset.countdown;
        if (!targetIso) return;
        const target = new Date(targetIso).getTime();
        const now = Date.now();
        const diff = Math.max(0, target - now);

        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff / 3600000) % 24);
        const mins = Math.floor((diff / 60000) % 60);
        const secs = Math.floor((diff / 1000) % 60);

        const dEl = el.querySelector('[data-d]');
        const hEl = el.querySelector('[data-h]');
        const mEl = el.querySelector('[data-m]');
        const sEl = el.querySelector('[data-s]');
        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(mins);
        if (sEl) sEl.textContent = pad(secs);

        if (diff === 0) {
          el.classList.add('countdown-done');
          el.dispatchEvent(new CustomEvent('countdown:done', { bubbles: true }));
        }
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  // ----- MANIFESTO CHAPTERS -----
  function initManifesto() {
    const wrap = document.querySelector('[data-manifesto]');
    if (!wrap) return;

    const navItems = wrap.querySelectorAll('[data-chapter-nav]');
    const panes = wrap.querySelectorAll('[data-chapter-pane]');
    const prevBtn = wrap.querySelector('[data-chapter-prev]');
    const nextBtn = wrap.querySelector('[data-chapter-next]');

    let active = 0;

    function show(i) {
      i = Math.max(0, Math.min(panes.length - 1, i));
      active = i;
      navItems.forEach((n, idx) => n.classList.toggle('active', idx === i));
      panes.forEach((p, idx) => {
        p.style.display = idx === i ? 'block' : 'none';
      });
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === panes.length - 1;
    }

    navItems.forEach((n, idx) => {
      n.addEventListener('click', () => show(idx));
    });
    if (prevBtn) prevBtn.addEventListener('click', () => show(active - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(active + 1));

    show(0);
  }

  // ----- MOBILE MENU -----
  function initMobileMenu() {
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const open = menu.getAttribute('data-open') === 'true';
      menu.setAttribute('data-open', String(!open));
      document.body.style.overflow = !open ? 'hidden' : '';
    });
  }

  // ----- CART COUNT FROM SHOPIFY -----
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        const els = document.querySelectorAll('[data-cart-count]');
        els.forEach(el => {
          el.textContent = cart.item_count;
          el.classList.toggle('has-items', cart.item_count > 0);
        });
      })
      .catch(() => {});
  }

  // ----- NEWSLETTER SUBMIT (Shopify customer create) -----
  function initNewsletter() {
    const forms = document.querySelectorAll('[data-newsletter-form]');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const btn = form.querySelector('[type="submit"]');
        const success = form.querySelector('[data-newsletter-success]');
        if (btn) {
          btn.dataset.originalText = btn.textContent;
          btn.textContent = 'Submitting…';
        }
        // Shopify will handle the actual submit. We just provide UI feedback.
        // After Shopify redirects back with ?customer_posted=true, show success.
      });
    });

    if (window.location.search.includes('customer_posted=true')) {
      const successEls = document.querySelectorAll('[data-newsletter-success]');
      successEls.forEach(el => el.style.display = 'block');
    }
  }

  // ----- ADD TO CART AJAX -----
  function initAddToCart() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) {
          btn.dataset.originalText = btn.textContent;
          btn.textContent = 'Adding…';
          btn.disabled = true;
        }

        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
          .then(r => r.json())
          .then(item => {
            if (btn) {
              btn.textContent = '✓ Added to Bag';
              setTimeout(() => {
                btn.textContent = btn.dataset.originalText || 'Add to Bag';
                btn.disabled = false;
              }, 1800);
            }
            refreshCartCount();
          })
          .catch(err => {
            if (btn) {
              btn.textContent = btn.dataset.originalText || 'Add to Bag';
              btn.disabled = false;
            }
            console.error('Add to cart failed:', err);
          });
      });
    });
  }

  // ----- INIT -----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  function start() {
    initCountdown();
    initManifesto();
    initMobileMenu();
    initNewsletter();
    initAddToCart();
    refreshCartCount();
  }
})();
